import moment from 'moment'
import 'moment/locale/pl'
import { useTranslation } from 'react-i18next'
import { toDateInputValue } from '../common/availabilityUtils'

const formatDate = (value, locale) => {
	if (!value) return '—'
	const date = moment(value).locale(locale)
	return date.isValid() ? date.format('DD.MM.YYYY') : '—'
}

const formatDateTime = (value, locale) => {
	if (!value) return '—'
	const date = moment(value).locale(locale)
	return date.isValid() ? date.format('DD.MM.YYYY HH:mm') : '—'
}

export default function AvailabilitySummary({ availability }) {
	const { t, i18n } = useTranslation()
	const momentLocale = (i18n.resolvedLanguage || i18n.language || 'en').startsWith('pl') ? 'pl' : 'en'
	const slots = Array.isArray(availability?.slots) ? availability.slots : []
	const startDate = availability?.startDate || availability?.dateFrom
	const endDate = availability?.endDate || availability?.dateTo
	const isSingleDay = toDateInputValue(startDate) === toDateInputValue(endDate)

	return (
		<div className="flex">
			<div className="flex h-full w-full flex-col rounded-xl border border-gray-200 bg-white shadow-sm">
				<div className="border-b border-gray-200 p-6">
					<h2 className="text-lg font-semibold text-gray-900">
						{t('trainingAvailability.details.title')}
					</h2>
				</div>

				<div className="flex-1 space-y-4 p-6">
					{isSingleDay ? (
						<div className="flex items-center justify-between gap-4">
							<span className="text-sm text-gray-600">{t('trainingAvailability.form.fields.date')}</span>
							<span className="text-sm font-medium text-gray-900">
								{formatDate(startDate, momentLocale)}
							</span>
						</div>
					) : (
						<>
							<div className="flex items-center justify-between gap-4">
								<span className="text-sm text-gray-600">{t('trainingAvailability.form.fields.dateFrom')}</span>
								<span className="text-sm font-medium text-gray-900">
									{formatDate(startDate, momentLocale)}
								</span>
							</div>

							<div className="flex items-center justify-between gap-4">
								<span className="text-sm text-gray-600">{t('trainingAvailability.form.fields.dateTo')}</span>
								<span className="text-sm font-medium text-gray-900">
									{formatDate(endDate, momentLocale)}
								</span>
							</div>
						</>
					)}

					<div className="flex items-center justify-between gap-4">
						<span className="text-sm text-gray-600">{t('trainingAvailability.details.fields.created')}</span>
						<span className="text-sm font-medium text-gray-900">
							{formatDateTime(availability?.created, momentLocale)}
						</span>
					</div>

					<div className="h-px bg-gray-200 my-2" />

					<div>
						<div className="text-sm text-gray-600 mb-2">{t('trainingAvailability.form.fields.slots')}</div>
						<div className="flex flex-wrap gap-2">
							{slots.length === 0 ? (
								<span className="text-sm font-medium text-gray-900">—</span>
							) : (
								slots.map(slot => (
									<span
										key={slot}
										className="inline-flex rounded-full bg-indigo-50 px-3 py-1 text-sm font-semibold text-indigo-700">
										{slot}
									</span>
								))
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
